import React, { useEffect } from "react";
import { useRoutes } from "../../Context/RoutesContext";
import style from "../../assets/jss/disal-main/Layouts/Gerencia";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import FormRoutes from "../../Component/Form/Routes";
import ModalSuccess from "../../Component/Modal/ModalExitoRoutes";
import LoadingOverlay from "../../Component/Loading/LoadingOverlay";

const useStyles = makeStyles(style);

const RoutesContent  = () => {
  const classes = useStyles();
  const miningSites = JSON.parse(localStorage.getItem('miningSites'));
  const { 
    routes,
    miningSite,
    selected,
    loading,
    scheduleInfo,
    setMiningSite,
    setSelected,
    fetchScheduleInfo 
  } = useRoutes();


  const handleClickRoute = (item) => {
    setSelected(item);
  };

  useEffect(() => {
    if (selected && selected.routeId) {
      fetchScheduleInfo(selected.routeId);
    }
  }, [selected, fetchScheduleInfo]);

  return (
    <div className={classes.content}>
      <Grid container className={classes.gerencia}>
        <Grid item xs={12} className={classes.filter}>
          <FormControl variant="outlined">
            <Select
              className={classes.filterSelectSmall}
              value={miningSite}
              onChange={(e) => {
                setMiningSite(e.target.value);
              }}
            >
              <MenuItem value={0}>Seleccione una planta</MenuItem>
              {miningSites.map((res, key) => {
                return (
                  <MenuItem key={key} value={res.id}>
                    {res.name}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={4} className={classes.listAdd}>
          <h3 className={classes.title}>Lista de las Rutas</h3>
          <List className={classes.listGerencia}>
            {routes.map((item, index) => (
              <ListItem
                button
                id={item.routeId}
                data-code={item.routeId}
                className={
                  classes.Listbutton +
                  (selected && selected.routeId === item.routeId ? " active-item" : null)
                }
                onClick={() => handleClickRoute(item)}
                key={index}
              >
                <p>
                  {item.description === null ? "" : item.description}
                  {item.plateNumber === null ? "" : ", " + item.plateNumber}
                </p>
              </ListItem>
            ))}
          </List>
        </Grid>
        <Grid item xs={8} className={classes.formGerencia}>
          <h3 className={classes.title}>Datos de la Ruta</h3>
          {scheduleInfo && selected && (
            <div
              style={{
                padding: "8px 16px",
                marginBottom: "12px",
                borderRadius: "4px",
                backgroundColor: scheduleInfo.scheduleType === "future" ? "#fff3e0" : 
                                 scheduleInfo.scheduleType === "current_with_future" ? "#e3f2fd" : "#e8f5e9",
                border: scheduleInfo.scheduleType === "future" ? "1px solid #ff9800" : 
                        scheduleInfo.scheduleType === "current_with_future" ? "1px solid #2196f3" : "1px solid #4caf50",
                color: scheduleInfo.scheduleType === "future" ? "#e65100" : 
                       scheduleInfo.scheduleType === "current_with_future" ? "#1565c0" : "#2e7d32",
                fontSize: "14px",
                fontWeight: 500
              }}
            >
              {scheduleInfo.message}
            </div>
          )}
          {selected ? <FormRoutes/> : (
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              No hay ruta seleccionada
            </div>
          )}
        </Grid>
      </Grid>
      <ModalSuccess />
      <LoadingOverlay open={loading} message="Guardando ruta..." />
    </div>
  )
}

export default RoutesContent;